import { Button, createTheme, MantineProvider } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Popups } from "@/components/@custom/Popups";
import { Toolbar } from "@/components/@custom/Toolbar";
import { Layout } from "@/pages/_layouts";
import { Role } from "@/store";
import { requireRoles } from "@/utils/requiredRoles";

const theme = createTheme({
  primaryColor: "primary",
  components: {
    Button: Button.extend({
      defaultProps: {
        size: "lg"
      }
    })
  }
});

export const Route = createFileRoute("/app")({
  component: RouteComponent,
  beforeLoad: requireRoles({ allowed: [Role.Motorista] }),
  head: () => ({
    meta: [{ title: "Início" }]
  })
});

function RouteComponent() {


  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Toolbar.Default />

      <Popups />
      <Layout.Base>
        <Outlet />
      </Layout.Base>
    </MantineProvider>
  );
}
